/// <reference types="./utils.d.mts" />
import * as $global from "../ds/web/javascript/global.mjs";
import * as $promise from "../gleam_javascript/gleam/javascript/promise.mjs";
import * as $bool from "../gleam_stdlib/gleam/bool.mjs";
import * as $decode from "../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $list from "../gleam_stdlib/gleam/list.mjs";
import * as $string from "../gleam_stdlib/gleam/string.mjs";
import * as $a from "../lustre/lustre/attribute.mjs";
import * as $mime_types from "../mime_types/mime_types.mjs";
import { toList } from "./gleam.mjs";
import {
  getDataFromEvent as get_data_from_event,
  allSettled as all_settled,
  sendBlockId as send_block_id,
  getProposalId as get_proposal_id,
  escapeHTML as escape_html,
} from "./utils.ffi.ts";

export {
  all_settled,
  escape_html,
  get_data_from_event,
  get_proposal_id,
  send_block_id,
};

function append_format(formats, types, is_hidden) {
  return $bool.guard(
    is_hidden,
    formats,
    () => { return $list.append(formats, types); },
  );
}

export function restrict_proposal(word_disallowed, narrative_disallowed) {
  let excel = toList([".xlsx", $mime_types.to_string(new $mime_types.Xlsx())]);
  let docx = toList([".docx", $mime_types.to_string(new $mime_types.Docx())]);
  let pdf = toList([".pdf", $mime_types.to_string(new $mime_types.Pdf())]);
  let _pipe = excel;
  let _pipe$1 = append_format(_pipe, docx, word_disallowed);
  let _pipe$2 = append_format(_pipe$1, pdf, narrative_disallowed);
  let _pipe$3 = $string.join(_pipe$2, ",");
  return ((_capture) => { return $a.attribute("accept", _capture); })(_pipe$3);
}

export function set_nil_timeout(timeout, fun) {
  $global.set_timeout(timeout, fun);
  return undefined;
}
